const React = require('react'),
    ReactDOM = require('react-dom'),
    App = React.createFactory(require('./../../components/app.view.jsx').App);

let mountNode = document.getElementById('react-main-mount');
let props = JSON.parse(document.getElementById('props').textContent);
ReactDOM.render(App(props), mountNode);
